var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeamless = function SvgSeamless(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.74C12.6569 12.74 14 10.1701 14 7C14 3.82989 12.6569 1.26 11 1.26C9.34315 1.26 8 3.82989 8 7C8 10.1701 9.34315 12.74 11 12.74Z",
    fill: "#676D73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04 11.87C7.71 11.95 7.36 12 7 12C4.24 12 2 9.76 2 7C2 4.24 4.24 2 7 2C7.36 2 7.71 2.05 8.04 2.13C8.43 1.57 8.92 1.01 9.53 0.5C8.75 0.19 7.9 0 7 0C3.14 0 0 3.14 0 7C0 10.86 3.14 14 7 14C7.9 14 8.75 13.81 9.53 13.5C8.92 12.99 8.43 12.43 8.04 11.87Z",
    fill: "#676D73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C14.1 0 13.25 0.19 12.47 0.5C13.08 1.01 13.57 1.57 13.96 2.13C14.29 2.05 14.64 2 15 2C17.76 2 20 4.24 20 7C20 9.76 17.76 12 15 12C14.64 12 14.29 11.95 13.96 11.87C13.57 12.43 13.08 12.99 12.47 13.5C13.25 13.81 14.1 14 15 14C18.86 14 22 10.86 22 7C22 3.14 18.86 0 15 0Z",
    fill: "#676D73"
  })));
};
export default SvgSeamless;